import Option from './Option'
import _ from 'lodash'
const all = 'Tous'
class Filter {
  constructor ({selected = null, firstOptionText = null, options = []}) {
    this.selected = selected// selected || all
    this.firstOptionItem = firstOptionText !== null ? new Option(firstOptionText, null) : new Option(all, all)
    this.values = [this.firstOptionItem].concat(options)
    // console.log('options', options)
    // console.log('values', this.values)
  }
  get isPlaceholder () { return this.firstOptionItem.value === this.selected }
  applyPermissions (allowedValues) {
    if (allowedValues == null || allowedValues.length === 0) {
      this.values = []
    } else {
      this.values = _.filter(this.values, (o) => {
        return allowedValues.includes(o.value)
      })
    }
    this.values = [this.firstOptionItem].concat(this.values)
  }
}
export default Filter



// WEBPACK FOOTER //
// ./src/lib/transfer-objects/Filter.js